import Vue from 'vue'
import Button from './button'
import ButtonGroup from './button-group'
import Icon from './icon'
import Input from './input'
import Row from './row'
import Col from './col'
import Layout from './layout'
import Header from './header'
import Sider from './sider'
import Content from './content'
import Footer from './footer'
import Toast from './toast'
import Plugin from './plugin'

Vue.component('l-button', Button)
Vue.component('l-icon', Icon)
Vue.component('l-button-group', ButtonGroup)
Vue.component('l-input', Input)
Vue.component('l-row', Row)
Vue.component('l-col', Col)
Vue.component('l-layout', Layout)
Vue.component('l-header', Header)
Vue.component('l-sider', Sider)
Vue.component('l-content', Content)
Vue.component('l-footer', Footer)
Vue.component('sk-toast', Toast)
Vue.use(Plugin)

new Vue({
  el: '#app',
  data() {
    return {
      loading: true
    }
  },
  created() {
    this.showToast()
  },
  methods: {
    showToast() {
      this.$toast('当前功能不稳定, 如果遇到 Bug 请关闭该功能。', {
        text: '知道啦',
        callback() {
          console.log('用户说他知道啦')
        }
      })
    },
    toggleLoading() {
      this.loading = !this.loading
    }
  }
})
